<template>
  <div class="row align-items-center">
    <div class="col-12 col-md-6 offset-md-3 mb-3">
      <canvas id="chart"></canvas>
    </div>
  </div>
</template>

<script>

import Chart from "chart.js/dist/chart.min"

export default {
  props: {
    'type' : String,
    'labels' : Array,
    'colors' : Array,
    'results': Array
  },
  data: function () {
    return {
    }
  },
  mounted() {
    const _this = this;

    const ctx = document.getElementById("chart")

    new Chart(ctx, {
      type: _this.type,
      data: {
        labels: _this.labels,
        datasets: [{
          label: '# of Votes',
          data: _this.results,
          backgroundColor: _this.colors,
          borderWidth: 1
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false
          }
        }
      }
    });
  },

  computed: {

  },

  methods: {

  }
}
</script>
